import { render } from "./content-table.vue?vue&type=template&id=343e5167&scoped=true&ts=true"
import script from "./content-table.vue?vue&type=script&lang=ts"
export * from "./content-table.vue?vue&type=script&lang=ts"

import "./content-table.vue?vue&type=style&index=0&id=343e5167&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343e5167"]])

export default __exports__